export const TIME_PICKER_MODES = {
  SINGLE: "single",
  RANGE: "range"
};

export const TIME_PICKER_STYLE = {
  NARROW: "narrow",
  WIDE: "wide"
};

export const TIME_PICKER_MODE_VALUES = Object.values(TIME_PICKER_MODES);
